<script lang="ts" setup>
const isShowBanner = useCookie('isShowBanner', {
  default: () => true,
})
const { t } = useI18n()
const toggleShowBanner = useToggle(isShowBanner)
</script>

<template>
  <Transition>
    <div
      v-show="isShowBanner"
      class="bg-[#7540EE] hover:bg-[#7540eee6] w-full h-14 flex flex-row items-center overflow-hidden z-3 relative"
    >
      <NuxtLink to="/token" target="_blank">
        <span class="absolute inset-0"></span>
      </NuxtLink>

      <div
        class="max-w-(--ui-container) mx-auto px-4 flex flex-row items-center justify-between w-full"
      >
        <div class="hidden lg:flex-1 lg:flex lg:items-center" />

        <div class="flex items-center gap-1.5 min-w-0">
          <div class="flex flex-row items-center gap-5">
            <div class="text-white text-sm tracking-wide">
              $LONG Token is coming Nov 6!
            </div>
            <div class="isolate">
              <NuxtLink
                to="/token"
                target="_blank"
                class="flex flex-row items-center text-center justify-center bg-black hover:bg-[#202020] text-sm rounded-full pl-3.5 pr-4.5 py-1.5 whitespace-pre"
              >
                <p class="text-white">Learn More</p>
              </NuxtLink>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end lg:flex-1">
          <button
            class="flex isolate hover:bg-[#0000001a] cursor-pointer rounded-lg p-1.5"
            @click="toggleShowBanner(false)"
          >
            <Icon name="material-symbols:close-rounded" class="size-5" />
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>
